import React from "react";
import { Space, Modal } from "antd";
import { AxUpload, AxButton, AxIconWrapper, AxDivider } from "@dynata/axiom3";

class Upload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      previewVisible: false,
      previewImage: "",
      previewTitle: "",
      fileList: [
        {
          uid: "-1",
          name: "image.png",
          status: "done",
          url: "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
        },
        {
          uid: "-2",
          name: "image.png",
          status: "done",
          url: "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
        },
        {
          uid: "-3",
          name: "image.png",
          status: "done",
          url: "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
        },
        {
          uid: "-4",
          name: "image.png",
          status: "done",
          url: "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
        },
        {
          uid: "-xxx",
          percent: 50,
          name: "image.png",
          status: "uploading",
          url: "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
        },
        {
          uid: "-5",
          name: "image.png",
          status: "error",
        },
      ],
    };

    this.handlePreview = this.handlePreview.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }
  getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }
  async handlePreview(file) {
    if (!file.url && !file.preview) {
      file.preview = await this.getBase64(file.originFileObj);
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
      previewTitle:
        file.name || file.url.substring(file.url.lastIndexOf("/") + 1),
    });
  }
  handleCancel() {
    this.setState({ previewVisible: false });
  }
  handleChange({ fileList }) {
    this.setState({ fileList });
  }

  render() {
    const { previewVisible, previewImage, fileList, previewTitle } = this.state;
    const uploadButton = (
      <div className="ax-upload-wall-btn">
        <AxIconWrapper type="regular" size="30" icon={"fa-plus"} />
        <div className="upload-text">Upload</div>
      </div>
    );
    return (
      <div className="section" id="upload">
        <Space direction="vertical">
          <Space size="large" direction="vertical">
            <h3>Upload</h3>
            <p>Upload file by selecting or dragging.</p>
            <table className="props-table">
              <thead>
                <tr>
                  <th>Property</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Default</th>
                  <th>Version</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>accept</td>
                  <td>
                    File types that can be accepted. See{" "}
                    <a href="https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#accept">
                      input accept Attribute
                    </a>
                  </td>
                  <td>string</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>action</td>
                  <td>Uploading URL</td>
                  <td>string | (file) =&gt; Promise&lt;string&gt;</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>beforeUpload</td>
                  <td>
                    Hook function which will be executed before uploading.
                    Uploading will be stopped with <code>false</code> or a
                    rejected Promise returned. When returned value is{" "}
                    <code>Upload.LIST_IGNORE</code>, the list of files that have
                    been uploaded will ignore it.{" "}
                    <strong>
                      Warning：this function is not supported in IE9
                    </strong>
                  </td>
                  <td>
                    (file, fileList) =&gt; boolean | Promise&lt;File&gt; |{" "}
                    <code>Upload.LIST_IGNORE</code>
                  </td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>customRequest</td>
                  <td>
                    Override for the default xhr behavior allowing for
                    additional customization and ability to implement your own
                    XMLHttpRequest
                  </td>
                  <td>function</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>data</td>
                  <td>
                    Uploading extra params or function which can return
                    uploading extra params
                  </td>
                  <td>object | (file) =&gt; object | Promise&lt;object&gt;</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>defaultFileList</td>
                  <td>Default list of files that have been uploaded</td>
                  <td>object[]</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>directory</td>
                  <td>
                    Support upload whole directory (
                    <a href="https://caniuse.com/#feat=input-file-directory">
                      caniuse
                    </a>
                    )
                  </td>
                  <td>boolean</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>disabled</td>
                  <td>Disable upload button</td>
                  <td>boolean</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>fileList</td>
                  <td>
                    List of files that have been uploaded (controlled). Here is
                    a common issue{" "}
                    <a href="https://github.com/ant-design/ant-design/issues/2423">
                      #2423
                    </a>{" "}
                    when using it
                  </td>
                  <td>
                    <a href="#UploadFile">UploadFile</a>[]
                  </td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>headers</td>
                  <td>Set request headers, valid above IE10</td>
                  <td>object</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>iconRender</td>
                  <td>Custom show icon</td>
                  <td>
                    (file: UploadFile, listType?: UploadListType) =&gt;
                    ReactNode
                  </td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>isImageUrl</td>
                  <td>Customize if render &lt;img /&gt; in thumbnail</td>
                  <td>(file: UploadFile) =&gt; boolean</td>
                  <td>
                    <a href="https://github.com/ant-design/ant-design/blob/4ad5830eecfb87471cd8ac588c5d992862b70770/components/upload/utils.tsx#L47-L68">
                      (inside implementation)
                    </a>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>itemRender</td>
                  <td>Custom item of uploadList</td>
                  <td>
                    <pre>{`(originNode: ReactElement, file: UploadFile, fileList: object[], actions: { download: function, preview: function, remove: function }) =&gt; React.ReactNode`}</pre>
                  </td>
                  <td>-</td>
                  <td>4.16.0</td>
                </tr>
                <tr>
                  <td>listType</td>
                  <td>
                    Built-in stylesheets, support for three types:{" "}
                    <code>text</code>, <code>picture</code> or{" "}
                    <code>picture-card</code>
                  </td>
                  <td>string</td>
                  <td>
                    <code>text</code>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>maxCount</td>
                  <td>
                    Limit the number of uploaded files. Will replace current one
                    when <code>maxCount</code> is <code>1</code>
                  </td>
                  <td>number</td>
                  <td>-</td>
                  <td>4.10.0</td>
                </tr>
                <tr>
                  <td>method</td>
                  <td>The http method of upload request</td>
                  <td>string</td>
                  <td>
                    <code>post</code>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>multiple</td>
                  <td>
                    Whether to support selected multiple file.{" "}
                    <code>IE10+</code> supported. You can select multiple files
                    with CTRL holding down while multiple is set to be true
                  </td>
                  <td>boolean</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>name</td>
                  <td>The name of uploading file</td>
                  <td>string</td>
                  <td>
                    <code>file</code>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>openFileDialogOnClick</td>
                  <td>Click open file dialog</td>
                  <td>boolean</td>
                  <td>true</td>
                  <td></td>
                </tr>
                <tr>
                  <td>previewFile</td>
                  <td>Customize preview file logic</td>
                  <td>
                    (file: File | Blob) =&gt; Promise&lt;dataURL: string&gt;
                  </td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>progress</td>
                  <td>Custom progress bar</td>
                  <td>
                    <a href="/components/progress/#API">ProgressProps</a>{" "}
                    (support <code>type="line"</code> only)
                  </td>
                  <td>
                    <pre>{`{ strokeWidth: 2, showInfo: false }`}</pre>
                  </td>
                  <td>4.3.0</td>
                </tr>
                <tr>
                  <td>showUploadList</td>
                  <td>
                    Whether to show default upload list, could be an object to
                    specify <code>showPreviewIcon</code>,{" "}
                    <code>showRemoveIcon</code>, <code>showDownloadIcon</code>,{" "}
                    <code>removeIcon</code> and <code>downloadIcon</code>{" "}
                    individually
                  </td>
                  <td>
                    boolean |{" "}
                    <pre>{`{ showPreviewIcon?: boolean, showDownloadIcon?: boolean, showRemoveIcon?: boolean, previewIcon?: ReactNode | (file: UploadFile) =&gt; ReactNode, removeIcon?: ReactNode | (file: UploadFile) =&gt; ReactNode, downloadIcon?: ReactNode | (file: UploadFile) =&gt; ReactNode }`}</pre>
                  </td>
                  <td>true</td>
                  <td>function: 4.7.0</td>
                </tr>
                <tr>
                  <td>withCredentials</td>
                  <td>The ajax upload with cookie sent</td>
                  <td>boolean</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onChange</td>
                  <td>
                    A callback function, can be executed when uploading state is
                    changing, see <a href="#onChange">onChange</a>
                  </td>
                  <td>function</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onDrop</td>
                  <td>
                    A callback function executed when files are dragged and
                    dropped into upload area
                  </td>
                  <td>(event: React.DragEvent) =&gt; void</td>
                  <td>-</td>
                  <td>4.16.0</td>
                </tr>
                <tr>
                  <td>onDownload</td>
                  <td>
                    Click the method to download the file, pass the method to
                    perform the method logic, do not pass the default jump to
                    the new TAB
                  </td>
                  <td>function(file): void</td>
                  <td>(Jump to new TAB)</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onPreview</td>
                  <td>
                    A callback function, will be executed when file link or
                    preview icon is clicked
                  </td>
                  <td>function(file)</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onRemove</td>
                  <td>
                    A callback function, will be executed when removing file
                    button is clicked, remove event will be prevented when
                    return value is false or a Promise which resolve(false) or
                    reject
                  </td>
                  <td>function(file): boolean | Promise</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>...others</td>
                  <td>
                    All extra props are passed down to the{" "}
                    <>
                      <AxButton
                        size="small"
                        type="link"
                        target="_blank"
                        href="https://4x.ant.design/components/upload/#API"
                      >
                        {`<Upload />`}
                      </AxButton>
                    </>{" "}
                    component.
                  </td>
                  <td></td>
                  <td>-</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <h3 id="UploadFile">
              <span>UploadFile</span>
              <a href="#UploadFile" className="anchor">
                #
              </a>
            </h3>

            <div className="prop-header">
              <p className="props-title">UploadFile</p>
            </div>

            <table className="props-table">
              <thead>
                <tr>
                  <th>Property</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Default</th>
                  <th>Version</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>crossOrigin</td>
                  <td>CORS settings attributes</td>
                  <td>
                    <code>'anonymous'</code> | <code>'use-credentials'</code> |{" "}
                    <code>''</code>
                  </td>
                  <td>-</td>
                  <td>4.20.0</td>
                </tr>
                <tr>
                  <td>name</td>
                  <td>File name</td>
                  <td>string</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>percent</td>
                  <td>Upload progress percent</td>
                  <td>number</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>status</td>
                  <td>Upload status. Show different style when configured</td>
                  <td>
                    <code>error</code> | <code>success</code> |{" "}
                    <code>done</code> | <code>uploading</code> |{" "}
                    <code>removed</code>
                  </td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>thumbUrl</td>
                  <td>Thumb image url</td>
                  <td>string</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>uid</td>
                  <td>unique id. Will auto generate when not provided</td>
                  <td>string</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>url</td>
                  <td>Download url</td>
                  <td>string</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
              </tbody>
            </table>
          </Space>
        </Space>

        <AxDivider orientation="left" plain>
          Default
        </AxDivider>
        <Space direction="vertical">
          <pre>{`<AxUpload multiple={true}>
  <AxButton color="neutral" type="secondary" size="large">
    <i className="fa-solid fa-upload"></i> Upload
  </AxButton>
</AxUpload>`}</pre>
          <AxUpload multiple={true}>
            <AxButton color="neutral" type="secondary" size="large">
              <i className="fa-solid fa-upload"></i> Upload
            </AxButton>
          </AxUpload>
        </Space>

        <AxDivider orientation="left" plain>
          Preview
        </AxDivider>
        <Space direction="vertical">
          <pre>{`<>
<AxUpload
  action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
  listType="picture-card"
  fileList={fileList}
  onPreview={this.handlePreview}
  onChange={this.handleChange}
>
  {fileList.length >= 8 ? null : uploadButton}
</AxUpload>
<Modal
  visible={previewVisible}
  title={previewTitle}
  footer={null}
  onCancel={this.handleCancel}
>
  <img alt="example" style={{ width: "100%" }} src={previewImage} />
</Modal>
</>`}</pre>
          <>
            <AxUpload
              action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
              listType="picture-card"
              fileList={fileList}
              onPreview={this.handlePreview}
              onChange={this.handleChange}
            >
              {fileList.length >= 8 ? null : uploadButton}
            </AxUpload>
            <Modal
              visible={previewVisible}
              title={previewTitle}
              footer={null}
              onCancel={this.handleCancel}
            >
              <img alt="example" style={{ width: "100%" }} src={previewImage} />
            </Modal>
          </>
        </Space>
      </div>
    );
  }
}
export default Upload;
